<template>
  <div class="aiitem flexsb">
    <div class="aiitem-left">
      <img :src="item.imgUrl" alt="" />
    </div>
    <div class="aiitem-right">
      <div class="top">
        <p class="font16 fontbig mr-20">{{ item.name }}</p>
        <p class="introduce">{{ item.introduce }}</p>
      </div>
      <div class="btm flexsb mt-36">
        <div class="flexfs">
          <div class="store flexcenter mr-20">
            <span class="font12 mr-4">评分</span>
            <span class="font18">{{ 
              item.score.toString().indexOf(".") == -1
                  ? item.score
                  : item.score.toFixed(1) 
            }}</span>
          </div>
          <div class="usage flexcenter">
            <span class="font12 mr-4">使用量</span>
            <span>{{ item.usedAmount }}</span>
          </div>
        </div>

        <div class="ml-52">发布时间：{{ item.createTime }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    item: Object,
  },
  data() {
    return {};
  },
  methods: {
    link(e, path) {
      e.stopPropagation();
      this.$router.push({
        path: path,
      });
    },
  },
};
</script>

<style lang="scss">
.aiitem {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  &-left {
    width: 180px;
    height: 149px;
    border-radius: 8px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 8px;
    }
  }
  &-right {
    width: calc(100% - 220px);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .top {
      p {
        color: #67799c;
      }
      .introduce{
        height: 100px;
        margin-bottom: -36px;
      }
    }
    .btm {
      color: #919caf;
      padding-bottom: 24px;
      .store {
        padding: 0 8px;
        height: 21px;
        background: #4f608b;
        border-radius: 0px 8px 0px 8px;
        color: #d6af76;
        text-align: center;
        font-size: 12px;
      }
      .usage {
        padding: 0 8px;
        height: 21px;
        background: #d6af76;
        border-radius: 0px 11px 0px 11px;
        color: #ffffff;
      }
    }
  }
}
</style>
